import authAxios from "../utils/authAxios";

const profileClient = {
    updateProfile: async (profileData) => {
        const formData = new FormData();

        if (profileData.firstName !== undefined && profileData.firstName !== null) {
            formData.append('firstName', profileData.firstName);
        }

        if (profileData.lastName !== undefined && profileData.lastName !== null) {
            formData.append('lastName', profileData.lastName);
        }

        if (profileData.email !== undefined && profileData.email !== null) {
            formData.append('email', profileData.email);
        }

        if (profileData.avatar) {
            formData.append('avatar', profileData.avatar);
        }

        return await authAxios(`/api/profile/update`, {
            method: 'POST',
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }, 'text');
    },

    getAvatar: async () => {
        try {
            const blob = await authAxios(`/api/profile/avatar`, {
                method: 'GET',
                headers: {
                    'Accept': 'image/png,image/jpeg,image/jpg',
                },
            }, 'blob');

            const imageUrl = URL.createObjectURL(blob);
            return imageUrl;
        } catch (error) {
            console.error('Error in getAvatar:', error);
            throw error;
        }
    },
};

export default profileClient;
